import auth from '@/middleware/modules/auth'

const ConversionsIndex = () => import(/* webpackChunkName: "_v-conversions" */ '@/views/analytics_conversions/Conversions/Index.vue')
const ConversionsTab = () =>
  import(/* webpackChunkName: "_v-conversions" */ '@/views/analytics_conversions/Conversions/Tabs/Conversions.vue')
const ContentTab = () => import(/* webpackChunkName: "_v-conversions" */ '@/views/analytics_conversions/Conversions/Tabs/Content.vue')

export default [
  {
    path: 'analytics/conversions',
    name: 'analytics-conversions',
    redirect: { name: 'analytics-conversions-overview' },
    props: (route) => ({ querySearch: route.query.search }),
    component: ConversionsIndex,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
    children: [
      {
        path: '/',
        name: 'analytics-conversions-overview',
        component: ConversionsTab,
        meta: {
          // breadcrumbs: ['iganalytics'],
          layout: 'app-layout',
          tab: 'conversions',
          middleware: [auth],
        },
      },
      {
        path: 'content',
        name: 'analytics-conversions-content',
        component: ContentTab,
        meta: {
          breadcrumbs: ['analytics-conversions-overview'],
          layout: 'app-layout',
          tab: 'content',
          middleware: [auth],
        },
      },
    ],
  },
]
